import { ensureAppConfig } from '@ms-cloudpack/config';
import { spawnSync } from 'child_process';
import { z } from 'zod/v4-mini';
import { mutationProcedure } from '../trpc/common.js';
import type { ApiParams } from '../types/ApiParams.js';

/**
 * Open the Cloudpack configuration file in VS Code.
 */
export async function openConfigEditor(params: ApiParams<void, 'session', 'config'>): Promise<void> {
  const cwd = params.ctx.session.config.appPath;
  const appConfigPath = await ensureAppConfig(cwd);

  spawnSync('code', ['--goto', appConfigPath], { cwd, stdio: 'inherit' });
}

// Attach a trpc procedure to the function.
openConfigEditor.procedure = mutationProcedure(openConfigEditor, z.void(), z.void());
